import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-diploma-modal',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './diploma-modal.component.html',
    styleUrl: './diploma-modal.component.scss',
})
export class DiplomaModalComponent {
    graphism: string;

    constructor(private activeModale: NgbActiveModal) {}

    close() {
        this.activeModale.dismiss();
    }

    getDiplomaPath(): string {
        return `assets/diploma/${this.graphism}/diploma.png`;
    }

    download() {
        const imageUrl = this.getDiplomaPath();
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = 'diplome.png';
        link.click();
    }
}
